import { component } from 'picoapp';
import { ClerkResponse } from '../../../typescript/Clerk';

interface RecommendationsConfig {
  clerkEndpoint: string
  clerkLabel: string
  clerkLimit: number
  productId: number
}

export default component(async (node) => {
  const productList = node.querySelector('[data-product-list]');
  const placeholderItems = node.querySelectorAll('[data-placeholder-item]');

  const config: RecommendationsConfig = JSON.parse(node.dataset.config);
  const {
    clerkEndpoint, clerkLabel, clerkLimit, productId,
  } = config;

  // eslint-disable-next-line consistent-return
  const fetchRecommendationItems = () => new Promise<string[]>((resolve) => {
    if (!Clerk) {
      console.error('Clerk not found on window. Please check that Clerk is enabled in theme settings'); // eslint-disable-line no-console
      resolve([]);
    }

    Clerk(
      'call',
      clerkEndpoint,
      {
        labels: [clerkLabel],
        products: [productId],
        limit: clerkLimit,
        attributes: ['handle'],
      },
      (clerkResponse: ClerkResponse) => {
        const handles = clerkResponse.product_data.map((item) => item.handle);

        Promise.all(handles.map(async (handle) => {
          const response = await fetch(`/products/${handle}?view=recommendation-item`);

          if (!response.ok) {
            return null;
          }

          return response.text();
        })).then((productItems) => resolve(productItems));
      },
      (clerkResponse: ClerkResponse) => {
        console.error(clerkResponse.message); // eslint-disable-line no-console
        resolve([]);
      },
    );
  });

  const renderRecommendationItems = (recommendationItems: string[]) => {
    placeholderItems.forEach((item) => item.remove());

    const html = recommendationItems.join('');
    productList.insertAdjacentHTML('beforeend', html);

    Clerk('click', '*[data-clerk-product-id]');
    document.dispatchEvent(new Event('app:mount'));
  };

  const observe = () => {
    const observer = new IntersectionObserver(async (entries) => {
      if (entries[0].isIntersecting) {
        const recommendationItems = (await fetchRecommendationItems()).filter((product) => product);

        if (recommendationItems.length > 0) {
          renderRecommendationItems(recommendationItems);
        } else {
          node.remove();
        }

        observer.disconnect();
      }
    });

    observer.observe(node);
  };

  const init = () => {
    if (clerkLimit > 0) {
      observe();
    }
  };

  init();
});
